import React, { useState, useEffect, useRef } from 'react';
import { FormGroup, Input } from 'reactstrap';
import axios from 'axios';
import Message from '../../utils/Message';
import { Carousel, Form, Space } from 'antd';
import {
  LeftSquareFilled,
  RightSquareFilled,
  CheckCircleOutlined,
  StopOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';
import { Button, Popconfirm, AutoComplete } from 'antd';

import moment from 'moment';
import Lightbox from 'react-awesome-lightbox';
import '../../lightbox.css';

const ValidationModal = ({
  currentReportRowData,
  projectId,
  table,
  accessToken,
  currentDatabase,
  report,
  imageKey,
  validateNow,
  nextSlide,
  previousSlide,
  currentIndex,
  lastIndex,
  setError,
  loggedInUser,
}) => {
  const [form] = Form.useForm();
  const [editFields, setEditFields] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [statusDropdown, setStatusDropdown] = useState([]);
  const [status, setStatus] = useState('');
  const slider = useRef(null);
  const formRef = useRef(null);

  const [skuExists, setSkuExists] = useState(false);
  const [combinedReceiptExists, setCombinedReceiptsExist] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalReceiptAmount, setTotalReceiptAmount] = useState(0);

  const [searchValue, setSearchValue] = useState({});
  const [searching, setSearching] = useState({});
  const [searchValue2, setSearchValue2] = useState({});
  const [searching2, setSearching2] = useState({});
  const [fileData, setFileData] = useState('');

  // todo
  // 1. get the sku list from the api and display it at drop down
  // 2. if already approved then get the sku list array and display it back at the receipt modal
  // 3. send it as skuList array to backend

  useEffect(() => {
    if (currentReportRowData) {
      if (currentReportRowData.skuArray) {
        form.setFieldsValue({
          skuList: currentReportRowData.skuArray,
        });
      }
    }
  }, [currentReportRowData]);

  const updateSearchValue = (index, value) => {
    let search = { ...searching };
    search[index] = true;
    setSearching(search);

    let data = { ...searchValue };
    data[index] = value;
    setSearchValue(data);
  };

  const updateSearchValue2 = (index, value) => {
    let search = { ...searching2 };
    search[index] = true;
    setSearching2(search);

    let data = { ...searchValue2 };
    data[index] = value;

    setSearchValue2(data);
  };

  useEffect(() => {
    if (currentReportRowData && report) {
      let acc = { ...currentReportRowData };

      const fetchData = async () => {
        const data = report.editableField.map(async (e) => {
          let newD = { ...e };
          newD.value = acc[newD.field];
          newD.unitPrice = 0;
          newD.discount = 0;
          newD.totalAmount = 0;
          newD.totalReceiptAmount =
            acc[newD.field] && acc[newD.field].amount
              ? acc[newD.field].amount
              : 0;
          newD.reason = '';

          if (newD.type === 'date') {
            newD.value = moment(newD.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
          }

          //for long list pai
          if (newD.type === 'longListApi') {
            const resData = await axios.post(newD.longListApi, {
              campaignId: loggedInUser ? loggedInUser.campaignId : '',
            });
            newD.dropdown = resData.data.data;

            newD.required =
              !newD.required ||
              newD.required === 'text' ||
              newD.required === 'false'
                ? false
                : true;
          }

          // for skus
          if (newD.type === 'skuList') {
            const resData = await axios.post(newD.skuList, {
              campaignId: loggedInUser ? loggedInUser.campaignId : '',
            });

            newD.dropdown = resData.data.data;

            newD.required =
              !newD.required ||
              newD.required === 'text' ||
              newD.required === 'false'
                ? false
                : true;
          }

          return newD;
        });
        return Promise.all(data);
      };

      fetchData().then((data) => {
        const statusData = data.find(
          (data) => data.field === 'status' || data.field === 'action'
        );
        const nonStatusData = [];
        data.forEach((data) => {
          if (data.field === 'action' || data.field === 'status') {
            return;
          } else {
            nonStatusData.push(data);
          }
        });
        if (statusData) {
          setStatusDropdown(statusData.dropdown ? statusData.dropdown : []);
        }

        setEditFields(nonStatusData);
      });
    }
  }, [currentReportRowData, report]);

  const updateData = (e, index) => {
    e.preventDefault();
    let acc = [...editFields];
    acc[index].value = e.target.value;
    setEditFields(acc);
  };

  const updateDataDropdown = (value, index, dropdownData) => {
    let dataUpdated = '';

    if (dropdownData) {
      const d2 = dropdownData.find((each) => each.label == value);
      dataUpdated = d2 ? d2.value : '';
    }
    let acc = [...editFields];

    if (dataUpdated) {
      acc[index].value = dataUpdated;
    } else {
      acc[index].value = value;
    }
    setEditFields(acc);
  };

  // submit form data to server
  function updateCurrentData(values) {
    let acc = [...editFields];

    let upData = {}; // updating data
    acc.forEach((each) => {
      upData[each.field] = each.value;
      if (each.sku) {
        upData[each.field + 'Price'] = each.unitPrice;
        upData[each.field + 'Discount'] = each.discount;
      }

      if (each.type === 'skuList') {
        const allSku = editFields.find((each) => each.type === 'skuList');

        const updatedSkuList = values.skuList.map((each, idx) => {
          const getId = allSku.dropdown.find((e) => e.label === each.skuId);
          return {
            ...each,
            skuId: getId?.value || '',
          };
        });

        upData.skuList = updatedSkuList;
      }
    });

    upData.id = currentReportRowData.id
      ? currentReportRowData.id
      : currentReportRowData._id;
    upData.token = accessToken;
    upData.status = status;
    upData.action = status;
    upData.validatorId = loggedInUser && loggedInUser._id;

    upData.validatorName = loggedInUser && loggedInUser.username;
    upData.campaignId = loggedInUser ? loggedInUser.campaignId : '';

    if (projectId === '612748b281d14cbcf72ea738') {
      upData.password = loggedInUser && loggedInUser.password;
    }

    if (fileData) {
      const fileUpload = editFields.find(
        (each) => each.type === 'uploadFileApi'
      );

      const formData = new FormData();
      formData.append(fileUpload.field || 'File', fileData);
      formData.append('id', currentReportRowData.id);
      formData.append('token', accessToken);

      try {
        axios.post(fileUpload.uploadFileApi, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } catch (error) {
        console.error('Error:', error);
      }
    }
    axios
      .post(report.editEndPoint, upData)
      .then((data) => {
        const updateValidator = {
          validatorId: loggedInUser && loggedInUser._id,
          type: status,
          projectId: projectId,
        };
        axios
          .post('/api/account/updateValidator', updateValidator)
          .then()
          .catch((err) => {
            setErrorMsg(err.response.data ? err.response.data.error : '');
          });
        // update validation count end
        setSearching2({});
        setSearching({});
        validateNow();
        setErrorMsg('');
        setError('');
        setTotalReceiptAmount(0);
      })
      .catch((err) => {
        setErrorMsg(
          err.response.data
            ? err.response.data.error || err.response.data.message
            : ''
        );
      });
  }

  const handleOk = () => {
    setTimeout(() => {
      document.getElementById('myFunction').click();
    }, 100);
  };

  const updateSkuData = (e, each, index, name) => {
    e.preventDefault();
    setSkuExists(true);

    let acc = [...editFields];
    if (name) {
      acc[index][name] = e.target.value;

      if (name === 'unitPrice' || name === 'totalUnit') {
        acc[index].totalAmount =
          Number(acc[index].value) * Number(acc[index].unitPrice);
      }

      if (acc[index].discount) {
        const curTotal =
          Number(acc[index].value) * Number(acc[index].unitPrice);
        const total = curTotal - Number(acc[index].discount);
        acc[index].totalAmount = total;
      }
    }

    let adder = 0;
    acc.forEach((accEach) => {
      adder += accEach.totalAmount;
    });

    setEditFields(acc);
    setTotalAmount(adder);
  };

  const updateCombinedReceiptsData = (e, each, index, name) => {
    e.preventDefault();
    setCombinedReceiptsExist(true);

    let acc = [...editFields];
    if (!acc[index].value) {
      acc[index].value = {};
    }

    if (name) {
      acc[index].value[name] = e.target.value;

      if (name === 'amount') {
        acc[index].totalReceiptAmount = e.target.value;
      }
    }

    let adder = 0;
    acc.forEach((accEach) => {
      adder += Number(accEach.totalReceiptAmount);
    });

    setEditFields(acc);
    setTotalReceiptAmount(adder);
  };

  let requireCheck;

  async function downloadImage() {
    const today = new Date().getMinutes();
    const image = await fetch(currentReportRowData[imageKey]);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);

    const link = document.createElement('a');
    link.href = imageURL;

    link.download = `photo-${today}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleCancel = () => {
    return;
  };

  // console.log('editFields', editFields);

  return (
    <div>
      {errorMsg && (
        <Message color="danger" fullWidth="true">
          {errorMsg}
        </Message>
      )}

      {currentReportRowData ? (
        <div>
          <div className="position-relative">
            <div
              className="left-arrow"
              onClick={() => previousSlide()}
              style={{ cursor: 'pointer' }}
            >
              <LeftSquareFilled
                style={{
                  fontSize: '2.5rem',
                  color: currentIndex === 0 ? '#ddd' : '#051D49',
                }}
              />
            </div>

            <Carousel dots={false} effect="fade" ref={slider} draggable={true}>
              <>
                {report && report.reportType === 'action-without-receipt' ? (
                  <div
                    className="d-flex w-100 "
                    style={{ background: '#F8F8F8' }}
                  >
                    <div style={{ width: '45%' }}>
                      {currentReportRowData ? (
                        <div className="mt-4 ps-5">
                          <label htmlFor="Subject">Subject</label>

                          <Input
                            type={'textarea'}
                            name={'subject'}
                            value={currentReportRowData.subject}
                            style={{ width: '100%' }}
                            rows="5"
                          />

                          <div className="mt-4"></div>
                          <label htmlFor="Description ">Description</label>

                          <Input
                            type={'textarea'}
                            name={'description'}
                            value={currentReportRowData.description}
                            style={{ width: '100%' }}
                            rows="10"
                          />
                        </div>
                      ) : null}
                    </div>
                    <Form
                      ref={formRef}
                      onFinish={updateCurrentData}
                      style={{ padding: '1rem' }}
                      form={form}
                      layout="vertical"
                      className="w-50 ms-4"
                    >
                      <FormGroup>
                        {editFields &&
                          editFields.map((each, idx) => {
                            return (
                              <div key={idx}>
                                {each.type === 'dropdown' ? (
                                  <FormGroup className="mt-3 fw-bold">
                                    <label
                                      htmlFor="receipt Channel"
                                      style={{ marginBottom: '-1rem' }}
                                    >
                                      {each.label}
                                    </label>

                                    <div>
                                      <AutoComplete
                                        style={{ width: '100%' }}
                                        name="dropdown"
                                        options={each.dropdown.map(
                                          (drop, i) => {
                                            return {
                                              value: drop,
                                              label: drop,
                                            };
                                          }
                                        )}
                                        allowClear
                                        notFoundContent="Not found"
                                        value={
                                          searching2[idx]
                                            ? searchValue2[idx]
                                            : each.value
                                        }
                                        onChange={(value) => {
                                          updateSearchValue2(
                                            idx,
                                            value,
                                            each.value
                                          );
                                        }}
                                        onSelect={(e) => {
                                          updateSearchValue2(idx, e);
                                          updateDataDropdown(
                                            e,
                                            idx,
                                            each.dropdown
                                          );
                                        }}
                                        placeholder="Searchable dropdown"
                                        filterOption={(inputValue, option) =>
                                          option.value &&
                                          option.value
                                            .toUpperCase()
                                            .indexOf(
                                              inputValue &&
                                                inputValue.toUpperCase()
                                            ) !== -1
                                        }
                                      />
                                    </div>
                                  </FormGroup>
                                ) : each.type === 'longListApi' ? (
                                  <FormGroup className="mt-3 fw-bold">
                                    <label
                                      htmlFor="receipt Channel"
                                      style={{ marginBottom: '-1rem' }}
                                    >
                                      {each.label}
                                    </label>

                                    <div>
                                      <AutoComplete
                                        style={{ width: '100%' }}
                                        name="dropdown"
                                        options={each.dropdown.map(
                                          (drop, i) => {
                                            return {
                                              newValue: drop.value,
                                              value: drop.label,
                                              label: drop.label,
                                            };
                                          }
                                        )}
                                        allowClear
                                        value={
                                          searching[idx]
                                            ? searchValue[idx]
                                            : each.value
                                        }
                                        onChange={(value) => {
                                          updateSearchValue(idx, value);
                                        }}
                                        onSelect={(e) => {
                                          updateSearchValue(idx, e);
                                          updateDataDropdown(
                                            e,
                                            idx,
                                            each.dropdown
                                          );
                                        }}
                                        notFoundContent="Not found"
                                        placeholder="Searchable dropdown"
                                        filterOption={(inputValue, option) => {
                                          return (
                                            option.label &&
                                            option.label
                                              .toUpperCase()
                                              .indexOf(
                                                inputValue &&
                                                  inputValue.toUpperCase()
                                              ) !== -1
                                          );
                                        }}
                                      />
                                    </div>
                                  </FormGroup>
                                ) : each.type === 'uploadFileApi' ? (
                                  <div className="mt-3">
                                    <label htmlFor="uploadFileApi">
                                      <div className="fw-bold">
                                        {each.label}
                                      </div>
                                    </label>

                                    <input
                                      type="file"
                                      accept=".jpg, .jpeg, .png, .pdf, .webp"
                                      onChange={(e) =>
                                        setFileData(e.target.files[0])
                                      }
                                    />
                                  </div>
                                ) : (
                                  <div className="mt-3 fw-bold">
                                    {each.field === 'comment_id' ? (
                                      <Input
                                        type={each.type}
                                        name={each.field}
                                        value={each.value}
                                        rows="15"
                                        disabled
                                        style={{ display: 'none' }}
                                      />
                                    ) : each.field === 'course_id' ? (
                                      <div div className="mt-4">
                                        <Input
                                          type={each.type}
                                          name={each.field}
                                          value={`Module ${each.value - 1}`}
                                          rows="15"
                                          disabled
                                        />
                                      </div>
                                    ) : (
                                      <>
                                        <label htmlFor="receipt Number">
                                          {each.label}
                                        </label>

                                        <Input
                                          type={each.type}
                                          name={each.field}
                                          value={each.value}
                                          onChange={(e) => updateData(e, idx)}
                                          rows="15"
                                        />
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                      </FormGroup>

                      <button
                        id="myFunction"
                        type="submit"
                        style={{ display: 'none' }}
                      ></button>
                    </Form>
                  </div>
                ) : (
                  <div
                    style={{ height: '85vh', color: '#fff' }}
                    className="d-flex"
                  >
                    <div className="left-image-container">
                      {currentReportRowData &&
                      currentReportRowData[imageKey] &&
                      Array.isArray(currentReportRowData[imageKey]) &&
                      currentReportRowData[imageKey].length > 1 ? (
                        currentReportRowData[imageKey].map((e, idx) => {
                          return (
                            <div key={idx} className="d-flex flex-wrap p-1">
                              <img
                                src={e}
                                alt="img-receipt"
                                style={{ objectFit: 'contain', width: '100%' }}
                              />
                            </div>
                          );
                        })
                      ) : (
                        <div>
                          <Lightbox
                            image={currentReportRowData[imageKey]}
                            alt="receipt"
                          />
                        </div>
                      )}
                    </div>

                    <div className="right-input-container">
                      <Form
                        ref={formRef}
                        onFinish={updateCurrentData}
                        style={{ padding: '1rem' }}
                        form={form}
                        layout="vertical"
                      >
                        <FormGroup>
                          {editFields &&
                            editFields.map((each, idx) => {
                              if (
                                each.value === 'Rejected' ||
                                each.value === 'rejected'
                              ) {
                                requireCheck = 1;
                              }

                              return (
                                <div key={idx}>
                                  {each.type === 'dropdown' ? (
                                    <FormGroup className="mt-3 fw-bold">
                                      <label
                                        htmlFor="receipt Channel"
                                        style={{ marginBottom: '-1rem' }}
                                      >
                                        {each.label}
                                      </label>

                                      <div>
                                        <AutoComplete
                                          style={{ width: '100%' }}
                                          name="dropdown"
                                          options={each.dropdown.map(
                                            (drop, i) => {
                                              return {
                                                value: drop,
                                                label: drop,
                                              };
                                            }
                                          )}
                                          allowClear
                                          notFoundContent="Not found"
                                          value={
                                            searching2[idx]
                                              ? searchValue2[idx]
                                              : each.value
                                          }
                                          onChange={(value) => {
                                            updateSearchValue2(
                                              idx,
                                              value,
                                              each.value
                                            );
                                          }}
                                          onSelect={(e) => {
                                            updateSearchValue2(idx, e);
                                            updateDataDropdown(
                                              e,
                                              idx,
                                              each.dropdown
                                            );
                                          }}
                                          placeholder="Searchable dropdown"
                                          filterOption={(inputValue, option) =>
                                            option.value &&
                                            option.value
                                              .toUpperCase()
                                              .indexOf(
                                                inputValue &&
                                                  inputValue.toUpperCase()
                                              ) !== -1
                                          }
                                        />
                                      </div>
                                    </FormGroup>
                                  ) : each.type === 'uploadFileApi' ? (
                                    <div>
                                      <label htmlFor="uploadFileApi">
                                        <div className="fw-bold">
                                          {each.label}
                                        </div>
                                      </label>

                                      <input
                                        type="file"
                                        accept=".jpg, .jpeg, .png, .pdf, .webp"
                                        onChange={(e) =>
                                          setFileData(e.target.files[0])
                                        }
                                      />
                                    </div>
                                  ) : each.type === 'longListApi' ? (
                                    <FormGroup className="mt-3 fw-bold">
                                      <label
                                        htmlFor="receipt Channel"
                                        style={{ marginBottom: '-1rem' }}
                                      >
                                        {each.label}
                                      </label>

                                      <div>
                                        <AutoComplete
                                          style={{ width: '100%' }}
                                          name="dropdown"
                                          options={each.dropdown.map(
                                            (drop, i) => {
                                              return {
                                                newValue: drop.value,
                                                value: drop.label,
                                                label: drop.label,
                                              };
                                            }
                                          )}
                                          allowClear
                                          value={
                                            searching[idx]
                                              ? searchValue[idx]
                                              : each.dropdown.find(
                                                  (drop) =>
                                                    drop.value === each.value
                                                )?.label || each.value
                                          }
                                          onChange={(value) => {
                                            updateSearchValue(idx, value);
                                          }}
                                          onSelect={(e) => {
                                            updateSearchValue(idx, e);
                                            updateDataDropdown(
                                              e,
                                              idx,
                                              each.dropdown
                                            );
                                          }}
                                          notFoundContent="Not found"
                                          placeholder="Searchable dropdown"
                                          filterOption={(
                                            inputValue,
                                            option
                                          ) => {
                                            return (
                                              option.label &&
                                              option.label
                                                .toUpperCase()
                                                .indexOf(
                                                  inputValue &&
                                                    inputValue.toUpperCase()
                                                ) !== -1
                                            );
                                          }}
                                        />
                                      </div>
                                    </FormGroup>
                                  ) : each.type === 'skuList' ? (
                                    <Form.List name="skuList" className="mt-2">
                                      {(fields, { add, remove }) => (
                                        <>
                                          {fields.map(
                                            ({ key, name, ...restField }) => (
                                              <div key={key}>
                                                <Form.Item
                                                  {...restField}
                                                  name={[name, 'skuId']}
                                                  label="Product"
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message: 'Input value!',
                                                    },
                                                  ]}
                                                  style={{
                                                    marginTop: '10px',
                                                  }}
                                                >
                                                  <AutoComplete
                                                    options={each.dropdown.map(
                                                      (item) => {
                                                        return {
                                                          label: item.label,
                                                          value: item.label,
                                                        };
                                                      }
                                                    )}
                                                    placeholder="Search for sku"
                                                    allowClear
                                                    filterOption={(
                                                      inputValue,
                                                      option
                                                    ) => {
                                                      return (
                                                        option.label
                                                          .toUpperCase()
                                                          .indexOf(
                                                            inputValue.toUpperCase()
                                                          ) !== -1
                                                      );
                                                    }}
                                                  />
                                                </Form.Item>
                                                <Space>
                                                  <Form.Item
                                                    {...restField}
                                                    name={[name, 'quantity']}
                                                    label="Quantity"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message: 'Input value!',
                                                      },
                                                    ]}
                                                  >
                                                    <Input
                                                      type="number"
                                                      min={0}
                                                    />
                                                  </Form.Item>
                                                  <Form.Item
                                                    {...restField}
                                                    name={[name, 'price']}
                                                    label="Price"
                                                    initialValue={0}
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message: 'Input value!',
                                                      },
                                                    ]}
                                                  >
                                                    <Input type="text" />
                                                  </Form.Item>

                                                  <div>
                                                    {fields && fields.length ? (
                                                      <MinusCircleOutlined
                                                        style={{ color: 'red' }}
                                                        onClick={() =>
                                                          remove(name)
                                                        }
                                                      />
                                                    ) : null}
                                                  </div>
                                                </Space>
                                              </div>
                                            )
                                          )}
                                          <Form.Item className="mt-2">
                                            <Button
                                              type="dashed"
                                              onClick={() => add()}
                                              block
                                              icon={<PlusOutlined />}
                                            >
                                              Add SKU
                                            </Button>
                                          </Form.Item>
                                        </>
                                      )}
                                    </Form.List>
                                  ) : each.type === 'combinedReceipts' ? (
                                    <>
                                      <div>
                                        <div className="d-flex">
                                          <div className="">
                                            <label
                                              className="text-muted"
                                              htmlFor="Unit Price"
                                              style={{
                                                marginBottom: '-1rem',
                                                fontSize: '0.8rem',
                                              }}
                                            >
                                              {each.label}
                                            </label>
                                            <Input
                                              type="text"
                                              value={
                                                (each.value &&
                                                  each.value.invoiceNo) ||
                                                ''
                                              }
                                              // placeholder={each.label}
                                              onChange={(e) =>
                                                updateCombinedReceiptsData(
                                                  e,
                                                  each,
                                                  idx,
                                                  'invoiceNo'
                                                )
                                              }
                                            />
                                          </div>
                                          <div className="mx-1">
                                            <label
                                              className="text-muted"
                                              htmlFor="Unit Price"
                                              style={{
                                                marginBottom: '-1rem',
                                                fontSize: '0.8rem',
                                              }}
                                            >
                                              Receipt Date
                                            </label>
                                            <Input
                                              type="date"
                                              name={each.field}
                                              value={
                                                (each.value &&
                                                  each.value.receiptDate) ||
                                                ''
                                              }
                                              onChange={(e) => {
                                                // updateData(e, idx);
                                                updateCombinedReceiptsData(
                                                  e,
                                                  each,
                                                  idx,
                                                  'receiptDate'
                                                );
                                              }}
                                              required={
                                                requireCheck
                                                  ? false
                                                  : each.required
                                              }
                                            />
                                          </div>
                                          <div className="">
                                            <label
                                              className="text-muted"
                                              htmlFor="Unit Price"
                                              style={{
                                                marginBottom: '-1rem',
                                                fontSize: '0.8rem',
                                              }}
                                            >
                                              Receipt Amount
                                            </label>
                                            <Input
                                              type="text"
                                              value={
                                                (each.value &&
                                                  each.value.amount) ||
                                                ''
                                              }
                                              onChange={(e) =>
                                                updateCombinedReceiptsData(
                                                  e,
                                                  each,
                                                  idx,
                                                  'amount'
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <div className="mt-3 fw-bold">
                                      <label htmlFor="receipt Number">
                                        {each.label}
                                      </label>

                                      {each.sku ? (
                                        <div style={{ marginTop: '-0.5rem' }}>
                                          <div className="d-flex">
                                            <div className="">
                                              <label
                                                className="text-muted"
                                                htmlFor="Unit Price"
                                                style={{
                                                  marginBottom: '-1rem',
                                                  fontSize: '0.8rem',
                                                }}
                                              >
                                                Total Units{' '}
                                                {projectId ===
                                                '63588b3280df19185fe612e5'
                                                  ? '(quantity)'
                                                  : ''}
                                              </label>
                                              <Input
                                                type="text"
                                                name={each.field}
                                                value={each.value}
                                                onChange={(e) => {
                                                  updateData(e, idx);
                                                  updateSkuData(
                                                    e,
                                                    each,
                                                    idx,
                                                    'totalUnit'
                                                  );
                                                }}
                                                required={
                                                  requireCheck
                                                    ? false
                                                    : each.required
                                                }
                                              />
                                            </div>
                                            <div className="mx-1">
                                              <label
                                                className="text-muted"
                                                htmlFor="Unit Price"
                                                style={{
                                                  marginBottom: '-1rem',
                                                  fontSize: '0.8rem',
                                                }}
                                              >
                                                Unit Price{' '}
                                                {projectId ===
                                                '63588b3280df19185fe612e5'
                                                  ? '(RM)'
                                                  : ''}
                                              </label>
                                              <Input
                                                type="text"
                                                value={each.unitPrice}
                                                onChange={(e) =>
                                                  updateSkuData(
                                                    e,
                                                    each,
                                                    idx,
                                                    'unitPrice'
                                                  )
                                                }
                                              />
                                            </div>
                                            {projectId !==
                                            '63588b3280df19185fe612e5' ? (
                                              <div>
                                                <label
                                                  className="text-muted"
                                                  htmlFor="Unit Price"
                                                  style={{
                                                    marginBottom: '-1rem',
                                                    fontSize: '0.8rem',
                                                  }}
                                                >
                                                  Discount
                                                </label>
                                                <Input
                                                  type="text"
                                                  value={each.discount}
                                                  onChange={(e) =>
                                                    updateSkuData(
                                                      e,
                                                      each,
                                                      idx,
                                                      'discount'
                                                    )
                                                  }
                                                />
                                              </div>
                                            ) : null}
                                          </div>
                                        </div>
                                      ) : (
                                        <Input
                                          type={each.type}
                                          name={each.field}
                                          value={each.value}
                                          onChange={(e) => updateData(e, idx)}
                                          required={
                                            requireCheck ? false : each.required
                                          }
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                        </FormGroup>

                        {combinedReceiptExists ? (
                          <>
                            <div className="">
                              <label
                                className="text-muted"
                                htmlFor="Unit Price"
                                style={{ marginBottom: '-1rem' }}
                              >
                                Subtotal Receipts Amount
                              </label>
                              <Input
                                type="text"
                                disabled
                                value={totalReceiptAmount}
                              />
                            </div>
                          </>
                        ) : null}

                        {skuExists &&
                        projectId !== '63588b3280df19185fe612e5' ? (
                          <>
                            <div className="">
                              <label
                                className="text-muted"
                                htmlFor="Unit Price"
                                style={{ marginBottom: '-1rem' }}
                              >
                                Final Total Receipt Amount
                              </label>
                              <Input
                                type="text"
                                disabled
                                value={totalAmount.toFixed(2)}
                              />
                            </div>
                          </>
                        ) : null}

                        <button
                          id="myFunction"
                          type="submit"
                          style={{ display: 'none' }}
                        ></button>
                      </Form>
                    </div>
                  </div>
                )}
              </>
            </Carousel>
            <div className="right-arrow">
              <RightSquareFilled
                onClick={() => nextSlide()}
                style={{
                  fontSize: '2.5rem',
                  cursor: 'pointer',
                  color: currentIndex + 1 === lastIndex ? '#ddd' : '#051D49',
                }}
              />
            </div>
          </div>
          <div className="d-flex mt-1 mt-4">
            <div className="w-50 mx-5">
              {report && report.reportType === 'action-without-receipt' ? (
                <div> </div>
              ) : (
                <Button onClick={downloadImage}>Download</Button>
              )}
            </div>

            <div className="d-flex ms-4">
              {statusDropdown.map((sta, id) => {
                return (
                  <div
                    key={id}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <Popconfirm
                      title="Are you sure？"
                      okText="Yes"
                      cancelText="No"
                      onClick={() => setStatus(sta)}
                      onConfirm={() => handleOk(sta)}
                      onCancel={handleCancel}
                    >
                      <Button
                        style={{
                          backgroundColor:
                            sta.toLowerCase() === 'approved' ? '#051D49' : '',
                          color: sta.toLowerCase() === 'approved' ? '#fff' : '',
                          cursor: 'pointer',
                          display: 'flex',
                        }}
                        icon={
                          sta.toLowerCase() === 'approved' ? (
                            <CheckCircleOutlined
                              style={{
                                color: '#fff',
                                fontSize: '19px',
                              }}
                            />
                          ) : sta.toLowerCase() === 'rejected' ? (
                            <StopOutlined style={{ fontSize: '19px' }} />
                          ) : (
                            <InfoCircleOutlined style={{ fontSize: '19px' }} />
                          )
                        }
                        className="mx-2"
                        type="submit"
                      >
                        <span>{sta} </span>
                      </Button>
                    </Popconfirm>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ValidationModal;
